import { render } from "./LabRejectionTab.vue?vue&type=template&id=7b305c90"
import script from "./LabRejectionTab.vue?vue&type=script&lang=js"
export * from "./LabRejectionTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__